import darkTheme from './darkTheme';
import './disonaTheme/fonts.less';

export const themes = {
  defaultTheme: {
    colors: {
      text: {
        textColor: '#7e8eaa',
        textColorAccent: '#ffffff',
        textColorDark: '#262635',
        textColorGreen: '#00CB5D',
        textColorLogout: '#ff3b3b',
        componentTextColor: '#7e8eaa',
      },
      background: {
        primaryColor: '#2D9CDB',
        secondaryColor: '#051932',
        backgroundComponent: '#031020',
        // menu
        menuBodyColor: '#ffffff',
        switchAccountBg: 'transparent',
        // backgrounds
        linearGradientLight:
          'linear-gradient(180deg, #2d9cdb 0%, #56ccf2 100%)',
        // card
        blueLinearGradient:
          'linear-gradient(rgb(36, 36, 60) 0%, rgb(86, 204, 242) 241.56%)',
        // colors of additional components
        borderColor: '#e8ebf2',
        modalBackground: '#ffffff',
        buttonLinkColor: '#2D9CDB',
        tagBackground: '#EDF6FA',
      },
      interactiveObjects: {},
    },
    assets: {
      images: {},
      icons: {},
      fonts: {
        small: '12px',
        normal: '16px',
        superLarge: '24px',
        fontWeight: '500',
        fontFamily: 'Roboto, sans-serif',
      },
    },
    sizing: {
      menuHeight: '64px',
      menuHeightMobile: '60px',
      menuWidth: '270px',
      menuPadding: '30px',
      borderRadius: '0px',
    },
    utils: {
      positive: '#5BDA8C',
      positiveDark: '#19ae53',
      danger: '#ff3b3b',
      accent: '#FF9248',
      accentLight: '#F79E1B',
      tertiary: '#FF897E',
    },
    pageSpecificTheme: {
      trading: {
        ...darkTheme,
        bgGraph: '#051932',
        chartBg: 'transparent',
        colors: {
          primary: {
            main: '#15aca3',
            light: '#3dcac1',
          },
          secondary: {
            dark: '#ff3434',
            main: '#ff4444',
          },
          error: {
            main: '#ff4444',
          },
          grey: {
            main: '#bbbbbb',
            light: '#e4e4e4',
            dark: '#505050',
          },
          green: {
            main: '#3abf57',
          },
          blue: {
            light: 'rgba(21, 172, 163, 0.07)',
            main: '#1890ff',
          },
          cyan: {
            main: '#2DD4DF',
          },
          orange: {
            main: '#ff8315',
          },
          black: {
            medium: '#484848',
            main: '#2f2f2f',
          },
          white: {
            light: '#f8f8f8',
            dark: '#f5f5f5',
            medium: '#fcfcfc',
            main: '#ffffff',
          },
          background: {
            main: '#fbfbfb',
          },
          border: {
            main: '#f1f1f1',
          },
          icon: {
            main: '#616161',
          },
          yellow: {
            main: '#ffcb44',
          },
        },
        heights: {
          header: 72,
        },
      },
    },
  },
  disonaTheme: {
    colors: {
      text: {
        textColorAccent: '#303742',
        textColorLightAccent: '#ffffff',
        textColorDark: '#262635',
        textColorGreen: '#00CB5D',
        textColorLogout: '#ffffff',
        componentTextColor: '#7e8eaa',
        headingColor: '#000000d9',
        textColor: '#FFFFFF',
        white60: 'rgba(255, 255, 255, 0.6)',
        white30: 'rgba(255, 255, 255, 0.3)',
        white15: 'rgba(255, 255, 255, 0.15)',
      },
      background: {
        primaryColor: '#001947',
        secondaryColor: '#003765',
        backgroundComponent: '#011947',
        blueThird: '#215988',
        red: '#D71A47',
        green: '#00F47F',
        // additional colors
        turqoiz: '#00D1DF',
        brightRed: '#FF1850',
        icons: '#00A4AF',
        iconsHover: '#ffffff',
        // menu
        menuBodyColor: '#011947',
        menuHover: '#00A4AF',
        switchAccountBg: '#013765', // возможно удалить
        // backgrounds
        linearGradientLight:
          'linear-gradient(180deg, #2d9cdb 0%, #56ccf2 100%)',
        linearGradient: 'linear-gradient(180deg, #24243c 0%, #56ccf2 241.56%)',
        // card
        blueLinearGradient: '#215988',
        // additional colors
        borderColor: 'transparent',
        buttonLinkColor: '#ffffff',
        componentTextColor: '#ffffff',
        modalBackground: '#013765',
      },
      interactiveObjects: {},
    },
    assets: {
      images: {},
      icons: {},
      fonts: {
        // fontFamily: 'Inter Light, sans-serif',
        // fontFamilyBold: 'Inter Extra Bold, sans-serif',
        fontFamily: 'FoundersGroteskMono-Light, sans-serif',
        small: '12px',
        normal: '16px',
        superLarge: '24px',
        fontWeight: '400',
      },
    },
    sizing: {
      menuHeight: '64px',
      menuHeightMobile: '60px',
      menuWidth: '100px',
      logoutWidth: '60px',
      menuPadding: '30px',
      borderRadius: '40px',
      h2: '20px',
      h3: '16px',
      text1: '16px',
      text2: '13px',
      text3: '10px',
      text4: '8px',
    },
    utils: {
      tagBackground: '#EDF6FA',
      positive: '#5BDA8C',
      positiveDark: '#19ae53',
      danger: '#ff3b3b',
      accent: '#FF9248',
      accentLight: '#F79E1B',
      tertiary: '#FF897E',
    },
    pageSpecificTheme: {
      trading: {
        chartBg: 'transparent',
        bgGraph: '#001947',
      },
    },
  },
};
